import React from 'react';
import Icon from '../Icon';

export default function SizeEditor({ sizes, onAdd, onRemove, onUpdate }) {
  return (
    <fieldset className="seller-size-editor">
      <legend>Размеры и габариты</legend>
      <p>
        Габариты используются для расчёта доставки. Указывайте вес в граммах,
        размеры упаковки — в сантиметрах.
      </p>
      {sizes.map((size, index) => (
        <div className="seller-size-row" key={size.id || index}>
          <label>
            Размер
            <input
              placeholder="42, M"
              aria-label={`Размер варианта ${index + 1}`}
              value={size.size}
              onChange={(e) => onUpdate(index, 'size', e.target.value)}
            />
          </label>
          <span className="seller-size-barcode">
            <small>Штрихкод</small>
            {size.barcode || 'Будет сгенерирован'}
          </span>
          {[
            ['weight_grams', 'Вес, г'],
            ['length_cm', 'Длина, см'],
            ['width_cm', 'Ширина, см'],
            ['height_cm', 'Высота, см'],
          ].map(([field, label]) => (
            <label key={field}>
              {label}
              <input
                type="number"
                min="1"
                step="1"
                aria-label={`${label}, вариант ${index + 1}`}
                value={size[field] || ''}
                onChange={(e) => onUpdate(index, field, e.target.value)}
              />
            </label>
          ))}
          {sizes.length > 1 && (
            <button
              className="seller-delete"
              type="button"
              aria-label={`Удалить вариант ${index + 1}`}
              onClick={() => onRemove(index)}
            >
              <Icon name="trash" size={18} />
            </button>
          )}
        </div>
      ))}
      <button type="button" className="btn btn-outline" onClick={onAdd}>
        <Icon name="plus" size={17} />
        Добавить размер
      </button>
    </fieldset>
  );
}
